import { BasePage } from 'src/pages/base.page';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SafeResourceUrl } from '@angular/platform-browser';
import { LoadingController, Platform } from '@ionic/angular';

import { Style, StatusBar } from '@capacitor/status-bar';

@Component({
    selector: 'webview-page',
    templateUrl: 'webview.page.html',
    styleUrls: ['webview.page.scss']
})
export class WebViewPage extends BasePage {
    constructor(
        public router: Router, 
        public loadingController: LoadingController,
        private activatedRoute: ActivatedRoute,
        private platform: Platform) {
            super(router)

            if (this.platform.is('ios')) {
                setTimeout(() => {
                    StatusBar.setStyle({
                        style: Style.Light
                    });
                }, 1000)
            }
    }

    safeURL: SafeResourceUrl
    title = ""

    ngOnInit() {
        const data = this.decodeData(this.activatedRoute.snapshot.paramMap.get('data'));
        this.title = data.title || ""
        this.safeURL = data.url
    }
}
